import React from 'react';
import { View, Text, StyleSheet, Animated } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { isPhone, isWeb, timePeriod, LEVELS } from '@helpers';
import { scale, notchTop } from '@components/frame';
import AnimatedHeader, { getHeight } from '@components/common/AnimatedHeader';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';

import TouchableElement from '@components/common/touchableElement';
import BackButton from '@components/common/backButton';
import Timeline from './components/timeline';
import LevelSelector from './components/levelSelector';
import NCFileLevel from './components/NCFileLevel';
import Svg from '@styles/icons/svg';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';

export const HeaderActionComponent = ({setActionsModalOpen, top, zIndex}) => {
  return <View key={'header-action'} style={{ position: 'absolute', right: scale(18), top: scale(isPhone ? (top ? 18 : 23) : 21), zIndex }}>
  <View style={{ flexDirection: 'row' }}>
    <View style={{ marginLeft: scale(36) }}>
      <TouchableElement onPress={() => setActionsModalOpen(true)}>
        {({ boxStyle }) => (
          <View style={[boxStyle]}>
            <Svg icon="more" width={scale(22)} height={scale(22)} color={'Button/Light/Primary'} />
          </View>
        )}
      </TouchableElement>
    </View>
  </View>
</View>
}

const DetailsHeader = ({
  C,
  fadeAnim,
  dummy = false,
  onBack,
  allSelected,
  selectedItem,
  noMachine,
  isNCFile,
  clampingTools,
  setSelectedLevel,
  showMachineInfo,
  isProperties,
  panelViewMode,
  isManufacture,
  setActionsModalOpen,
  batchText,
  selectedNCFileLevel,
  setSelectedNCFileLevel,
}) => {
  const { timePeriod: selectedTime } = useHandleParams();

  const offset = isPhone ? notchTop + scale(isManufacture ? 20 : 60) : isWeb ? scale(30) : 0;
  const inputRange = [-1, 0, offset, offset + 1];

  const headerHeight = getHeight();

  const HeaderAction = ({ top, zIndex, setActionsModalOpen }) => {
    if (isProperties) {
      return (
       <HeaderActionComponent {...{top, zIndex, setActionsModalOpen}} />
      );
    }

    return null;
  };

  return (
    <Animated.View
      style={
        dummy
          ? {
              opacity: 0,
            }
          : {
              marginTop: fadeAnim.interpolate({
                inputRange,
                outputRange: [0, 0, -offset, -offset],
              }),
              position: 'absolute',
              zIndex: 100000,
              backgroundColor: C('Background/Light/Detail'),
              width: '100%',
            }
      }
    >
      {(!isManufacture || isPhone) && (
        <Animated.View
          style={[
            {
              height: isPhone ? headerHeight : scale(37) + notchTop,
              zIndex: 10000,
              top: dummy
                ? 0
                : fadeAnim.interpolate({
                    inputRange,
                    outputRange: [0, 0, offset, offset],
                  }),
            },
          ]}
        >
          {isPhone && (
            <Animated.View
              style={{
                opacity: dummy
                  ? 0
                  : fadeAnim.interpolate({
                      inputRange: [0, 10],
                      outputRange: [1, 0],
                    }),
                zIndex: 10001,
              }}
            >
              <AnimatedHeader
                {...{
                  backText: i18n.t('Back'),
                  onBackPress: onBack || false,
                  actions: [{ component: HeaderAction, key: 'HeaderAction' }],
                  setActionsModalOpen,
                  text: isManufacture ? selectedItem?.machineStatus?.ncFileName : '',
                  C,
                  animated: false,
                  back: true,
                  backgroundColor: false,
                  borderBottomWidth: 0,
                  scale,
                  font,
                }}
              />
            </Animated.View>
          )}
        </Animated.View>
      )}
      {!isManufacture && (
        <Animated.View
          style={[
            {
              flexDirection: 'row',
              justifyContent: 'space-between',
              opacity: dummy
                ? 0
                : fadeAnim.interpolate({
                    inputRange: [0, 10],
                    outputRange: [1, 0],
                  }),
            },
            { paddingLeft: scale(18), paddingRight: scale(18) },
          ]}
        >
          <View style={{ marginTop: scale(isPhone ? 18 : 3), paddingRight: isPhone ? scale(75) : 0 }}>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Text
                style={[
                  {
                    color: C('Label / Light / Primary'),
                    fontWeight: 'bold',
                    fontSize: scale(20),
                    marginLeft: scale(7),
                    letterSpacing: scale(0.01),
                  },
                  font['Title 2'],
                ]}
                numberOfLines={1}
                ellipsizeMode={'middle'}
              >
                {selectedItem?.machineStatus?.ncFileName}
              </Text>
            </View>
          </View>
        </Animated.View>
      )}
      <View
        style={[
          {
            height: scale(isPhone ? 53 : 49),
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: scale(isPhone || !isManufacture ? 0 : 28),
            zIndex: 10000,
          },
          isPhone &&
            !allSelected && {
              borderBottomColor: C('Hairline/Light/Primary'),
              borderBottomWidth: StyleSheet.hairlineWidth,
            },
        ]}
      >
        <View
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          {isPhone || !isManufacture ? <View style={{ width: isPhone ? 0 : scale(100) }} /> : <BackButton />}
          <View style={{ flex: 1 }}>
            <Timeline
              {...{
                isNCFile,
                // setActiveTimeLine: dummy ? () => {} : setSelectedTime,
                activeTimeLine: selectedTime,
                blur: isPhone,
                colors: { light: '242, 243, 247', dark: '0, 0, 0' },
                ignoreNow: true,
                useProperties: true,
              }}
            />
          </View>
          {isPhone ? (
            <View />
          ) : (
            <View style={{ marginTop: scale(-18), width: scale(100) }}>
              <HeaderAction setActionsModalOpen={setActionsModalOpen} />
            </View>
          )}
        </View>
      </View>
      {showMachineInfo && isProperties && (
        <View
          style={[
            {
              height: scale(panelViewMode ? 58 : isPhone ? 49 : 43),
              alignContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            },
            isPhone && isNCFile
              ? {
                  borderBottomColor: C('Hairline/Light/Primary'),
                  borderBottomWidth: StyleSheet.hairlineWidth,
                }
              : {
                  paddingHorizontal: scale(18),
                },
          ]}
        >
          <LevelSelector
            {...{
              panelViewMode,
              ncFile: selectedItem?.machineStatus?.ncFile,
              partName: selectedItem?.machineStatus?.partDetails?.partName,
              partId: selectedItem?.machineStatus?.partDetails?.partId,
              setSelectedLevel,
              clampingTools,
              scale,
              font,
              isNCFile,
              blur: isPhone,
              big: !isPhone,
              noMachine,
              selectedItem,
              batchText,
            }}
          />
        </View>
      )}
      {isProperties && selectedTime == timePeriod.PROPERTIES && selectedLevel === 'ncFile' && (
        <View style={{ width: '100%', marginTop: scale(18) }}>
          <NCFileLevel
            {...{
              selectedNCFileLevel,
              setSelectedNCFileLevel,
              blur: isPhone,
              colors: { light: '242, 243, 247', dark: '0, 0, 0' },
            }}
          />
        </View>
      )}
    </Animated.View>
  );
};

const mapStateToProps = ({ user, membership }) => ({ user, membership });

export default connect(mapStateToProps, {})(ColorWrapper(DetailsHeader));
